import React from "react";
import { ListItem } from "../../../styled/common";
import { GuestNameItem, GuestButtonsWrapper, Dot } from "./styled";
import Button from "../../common/Buttons";
import trashIcon from "../../../assets/icons/rubbish-bin.svg"

type Guest = {
	name?:string,
	surname?:string
}
type GuestItemProps = {
  guest: Guest;
};

const defaultProps: GuestItemProps = {
  guest: {},
};

function GuestItem({ guest }: GuestItemProps) {
  console.log(guest);
	const click = () => {
		console.log('click')
	}
  return (
    <ListItem>
      <GuestNameItem>
        <Dot />
        {guest.name} {guest.surname}
      </GuestNameItem>
      <GuestButtonsWrapper>
        <Button label={"Edit"} onClick={click} basic>Edit</Button>
        <Button icon={trashIcon} onClick={click} iconBtn></Button>
      </GuestButtonsWrapper>
    </ListItem>
  );
}

GuestItem.defaultProps = defaultProps;

export { GuestItem };
